import { render, staticRenderFns } from "./ThemeConfigManagement.vue?vue&type=template&id=66393073&scoped=true"
import script from "./ThemeConfigManagement.vue?vue&type=script&lang=js"
export * from "./ThemeConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./ThemeConfigManagement.vue?vue&type=style&index=0&id=66393073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66393073",
  null
  
)

export default component.exports